import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { baseColors } from '../../Themes/colors';
var PillActionButton = function (_a) {
    var icon = _a.icon, label = _a.label, tooltip = _a.tooltip, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.bgColor, bgColor = _c === void 0 ? baseColors.fullWhite : _c, _d = _a.borderColor, borderColor = _d === void 0 ? baseColors.greyPreset[40] : _d, _e = _a.textColor, textColor = _e === void 0 ? baseColors.darkPreset[10] : _e, _f = _a.hoverOnly, hoverOnly = _f === void 0 ? false : _f, padding = _a.padding;
    var button = (React.createElement(Box, { role: "button", tabIndex: disabled ? -1 : 0, onClick: disabled ? undefined : onClick, onKeyDown: function (event) {
            if (disabled || !onClick)
                return;
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick(event);
            }
        }, sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.25,
            padding: padding !== null && padding !== void 0 ? padding : undefined,
            px: padding !== undefined ? undefined : 1.5,
            py: padding !== undefined ? undefined : 0.75,
            minWidth: label ? 64 : 'auto',
            borderRadius: '10px',
            border: hoverOnly ? 'none' : "1px solid ".concat(borderColor),
            backgroundColor: hoverOnly ? 'transparent' : bgColor,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            '&:hover': disabled ? undefined : (hoverOnly ? { backgroundColor: bgColor } : { opacity: 0.85 }),
            '& .pill-action-icon': { fontSize: 18, color: textColor, lineHeight: 1 },
            '& .pill-action-icon svg': { width: 18, height: 18, fill: textColor },
        } },
        React.createElement(Stack, { className: "pill-action-icon", alignItems: "center", justifyContent: "center" }, icon),
        label && (React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 600, color: textColor, lineHeight: 1.3, whiteSpace: 'nowrap' } }, label))));
    if (!tooltip)
        return button;
    return (React.createElement(Tooltip, { title: tooltip, arrow: true, placement: "top" },
        React.createElement("span", null, button)));
};
export default PillActionButton;
